import { useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/carbon/PageHeader/PageHeader";
import DeliveriesTable from "../../components/DeliveriesTable/DeliveriesTable";
import DeliveryStateFilter from "../../components/DeliveriesTable/DeliveryStateFilter";
import { PAGE_SIZES } from "../../components/carbon/DataTable/DataTable";
import { NetworkError } from "../../components";
import { useDeliveriesBySupplier } from "../../hooks/useDeliveries";
import { DeliveryState } from "../../types";

/**
 * Rebuilt on Carbon (Task 4, Deliveries flow) — `PageHeader` + the shared `DeliveriesTable`
 * (Carbon `DataTable`-backed), read-only: no `updateDelivery` is passed (schedule action never
 * renders) and `canUploadFile={false}` (the PO-file upload endpoint is buyer-company scoped by
 * T2, so a seller upload would only 403 — the un-filed rows show a neutral placeholder instead).
 */
const SupplierDeliveries = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  // undefined = the "All" option.
  const [state, setState] = useState<DeliveryState | undefined>(undefined);
  const { data: deliveries, isLoading, error } = useDeliveriesBySupplier(
    state,
    page,
    pageSize
  );

  const stateFilter = (
    <DeliveryStateFilter
      value={state}
      onChange={(next) => {
        setState(next);
        // A new filter always restarts at the first page.
        setPage(0);
      }}
    />
  );

  return (
    <div>
      <PageHeader title={t("deliveries.title")} />

      <div className="deliveries__filters">{stateFilter}</div>

      {error ? (
        <NetworkError />
      ) : (
        <DeliveriesTable
          deliveries={deliveries}
          pageNumber={page}
          setPageNumber={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          isLoading={isLoading}
          canUploadFile={false}
          emptyTitle={t("deliveries.filter.empty")}
        />
      )}
    </div>
  );
};

export default SupplierDeliveries;
